import { ReactNode, useCallback, useEffect, useReducer, useRef } from "react";

import { useAppStore } from "app/redux-store-interactions";
import { selectIsXRayActive } from "features/render/renderSlice";
import { registerMemoryStatsProvider } from "utils/memoryDiagnostics";

import {
    DispatchContext,
    DispatchHighlighted,
    initialState,
    isHighlightIdMutation,
    LazyStateContext,
    reducer,
    StateContext,
} from "./reducer";

export function HighlightedProvider({ children }: { children: ReactNode }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const lazyValue = useRef(state);
    lazyValue.current = state;
    const store = useAppStore();

    const lockedDispatch = useCallback<DispatchHighlighted>(
        (action) => {
            if (selectIsXRayActive(store.getState()) && isHighlightIdMutation(action)) {
                return;
            }
            dispatch(action);
        },
        [store],
    );

    useEffect(() => {
        return registerMemoryStatsProvider("highlightedState", () => ({
            idCount: lazyValue.current.ids.size,
            // ids and idArr share one sorted Uint32Array (4 bytes/id).
            residentBytes: lazyValue.current.ids.sortedIds.byteLength,
        }));
    }, []);

    return (
        <StateContext.Provider value={state}>
            <LazyStateContext.Provider value={lazyValue}>
                <DispatchContext.Provider value={lockedDispatch}>{children}</DispatchContext.Provider>
            </LazyStateContext.Provider>
        </StateContext.Provider>
    );
}
